import { Injectable } from "@angular/core";
import { MapperInterface } from "./mapper-inteface";
import { MetadatiRepertorioDTO } from "../dto/metadati-repertorioDTO";
import { MetadatiRepertorioVO } from "../vo/metadati-repertorioVO";

@Injectable({
  providedIn: "root",
})
export class MapperMetadatiRepertorio
  implements MapperInterface<MetadatiRepertorioDTO, MetadatiRepertorioVO> {
  constructor() {}

  convertVoToDto(vo: MetadatiRepertorioVO): MetadatiRepertorioDTO {
    if (vo != null) {
      const dto = new MetadatiRepertorioDTO();
      dto.anno = vo.anno;
      dto.data = vo.data;
      dto.id = vo.id;
      dto.numero = vo.numero;
      dto.mese  = vo.mese;
      dto.segnatura = vo.segnatura;
      return dto;
    } else {
      return null;
    }
  }
  convertDtoToVo(dto: MetadatiRepertorioDTO): MetadatiRepertorioVO {
    if (dto != null) {
      const vo = new MetadatiRepertorioVO();
      vo.anno = dto.anno;
      vo.data = dto.data;
      vo.id = dto.id;
      vo.mese  = dto.mese;
      vo.numero = dto.numero;
      vo.segnatura = dto.segnatura;

      // TODO terminare
      return vo;
    } else {
      return null;
    }
  }
  convertListVoToDto(e: MetadatiRepertorioVO[]): MetadatiRepertorioDTO[] {
    throw new Error("Method not implemented.");
  }
  convertListDtoToVo(t: MetadatiRepertorioDTO[]): MetadatiRepertorioVO[] {
    throw new Error("Method not implemented.");
  }
}
